import createReducer from 'utils/redux/createReducer'

const initialState = false

export default createReducer(initialState, {
    '@@router/LOCATION_CHANGE': (currentState, action) => {
        if (action.payload && action.payload.action == 'POP'){
            return true
        }
        return false
    },
    CHOOSE_ITEM: (currentState, action) => false
})



// WEBPACK FOOTER //
// ./src/reducers/shouldScroll.js